import store from '@/store'

export default [
  {
    path: '/vehicle-zone-profiles',
    name: 'vehicle-zone-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-zone-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      // await store.dispatch('subProgram/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/vehicle-zone-profiles/:id',
    name: 'vehicle-zone-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/vehicle-zone-profile/form.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('vehicleZoneProfile/find', to.params.id)
      next()
    }
  }
]
